import { BrandLockup } from '@agentic-flow-studio/shared/components/brand-lockup';
import { SkillViperLogo } from '@agentic-flow-studio/shared/components/skill-viper-logo';

/** Skill Viper's brand lockup for signed-out pages, above the centered card. */
export function PublicBrand() {
  return <BrandLockup brandName="Skill Viper" logo={<SkillViperLogo className="h-7 w-7" />} />;
}
